import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { deleteShippingZone } from "../../api/apiShipping";
import parseError from "../../utils/parseError";

export const useDeleteShippingZone = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteShippingZoneMutate, isPending: isDeleting } = useMutation({
        mutationFn: deleteShippingZone,
        onSuccess: (res) => {
            toast.success(res.message || "Shipping zone deleted successfully");
            queryClient.invalidateQueries(["shipping-zones"]);
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to delete shipping zone");
        },
    });

    return { deleteShippingZoneMutate, isDeleting };
};
